import axios from '@/libs/api.request';

// 查询下拉选择
export const fetchOptions = (data) => {
  const response = axios.request({
    url: '/admin/Currency/GetCurrencyDownList',
    method: 'post',
    data,
  });
  return response;
};

// 查询下拉选择
export const fetchDepOptions = (data) => {
  const response = axios.request({
    url: '/admin/Department/GetDepartmentDownList',
    method: 'get',
    data,
  });
  return response;
};

export const fetchTableOptions = (data) => {
  const response = axios.request({
    url: '/admin/CodeMakerForSugarTable/QueryTableName',
    method: 'post',
    data,
  });
  return response;
};
